module.exports = __webpack_public_path__ + "img/troyes-logo-icon.183319d2.png";